import gql from 'graphql-tag';

export const QUERY_STATIC_DATA = gql`
  query QUERY_STATIC_DATA {
    amenities {
      id
      code
      name
      iconCode
      filterable
    }
    layers {
      id
      name
      icon
      active
    }
    # propertyTypes {
    #   id
    #   name
    #   icon
    # }
  }
`;

export const QUERY_CONNECTED_PROPERTY_RESULTS = gql`
  query QUERY_CONNECTED_PROPERTY_RESULTS($propertyIds: [Int!], $checkin: String!, $checkout: String!, $skip: Boolean!) {
    getConnectedProperties(propertyIds: $propertyIds, checkin: $checkin, checkout: $checkout) @skip(if: $skip) {
      propertyId
      hotelCode
      availability
      ceilingRateAvailabile
      lowestRate {
        symbol
        position
        value
        formatted
        name
      }
      lowestRacRate {
        symbol
        position
        value
        formatted
        name
        type
      }
    }
  }
`;

export const QUERY_PROPERTY_RESULTS = gql`
  query QUERY_PROPERTY_RESULTS(
    $propertySearchInput: PropertySearchInput!
    $options: SearchQueryOptions!
    $skip: Boolean!
  ) {
    mapSearch(searchParameters: $propertySearchInput, options: $options) @skip(if: $skip) {
      properties {
        connected
        callForPricing
        timeZone
        geo {
          lat
          lng
        }
        id
        slug
        name
        cardImage {
          id
          href
        }
        distance
        availability
        startingPrice {
          name
          formatted
          value
          type
        }
        startingCeilingPrice {
          name
          formatted
          value
        }
        startingCeilingParams {
          percentageMaxMarkup
          percentageToTriggerMax
          percentageOnGDS
        }
        currency
        address {
          city
          region
          country
        }
      }
      favouriteProperties {
        id
      }
      propertyCount # Total Properties matching query regardless of pagination
      searchValue
      pointsOfInterest {
        id
        name
        layer {
          id
          name
          icon
        }
        metadata
        geo {
          lat
          lng
        }
      }
    }
  }
`;

export const QUERY_BOOKING_BYPASS_REASON = gql`
  query QUERY_BOOKING_BYPASS_REASON($bypassType: [BookingBypassTypes!]!) {
    getBookingBypassReasonsByType(bypassType: $bypassType) {
      id
      bypassReason
    }
  }
`;

export const MUTATION_ADD_PROPERTY_TO_ORGANIZATION_FAVOURITES = gql`
  mutation MUTATION_ADD_PROPERTY_TO_ORGANIZATION_FAVOURITES($propertyId: Int!) {
    addPropertyToOrganizationFavourites(propertyId: $propertyId) {
      message
    }
  }
`;

export const MUTATION_REMOVE_PROPERTY_FROM_ORGANIZATION_FAVOURITES = gql`
  mutation MUTATION_REMOVE_PROPERTY_FROM_ORGANIZATION_FAVOURITES($propertyId: Int!) {
    removePropertyFromOrganizationFavourites(propertyId: $propertyId) {
      message
    }
  }
`;
